import { OrganizationType } from "../services/types";

// get total price of an appointment
export const getTotalPriceOfServiceWithPatients = (
  productCost: number,
  numPatients: number,
  serviceCost: number,
  organization: OrganizationType,
  discount: number = 0
) => {
  let totalProductCost = 0;
  let totalServiceCost = 0;

  // it does not change with nume patients
  totalProductCost = numPatients * productCost;

  // specific rules for andes salud and biodata
  if (
    organization.nameUrl === "andessaludlab" ||
    organization.nameUrl === "laboratoriobiodata"
  ) {
    totalServiceCost = numPatients * serviceCost;
  }
  // alto salud specific rules
  else if (organization.nameUrl === "altotobalaba") {
    const limitNumPatiens = 3;
    const additionalCostByPatient = 5000;
    // this change based on patients number
    totalServiceCost = serviceCost;
    if (numPatients > limitNumPatiens) {
      totalServiceCost +=
        (numPatients - limitNumPatiens) * additionalCostByPatient;
    }
  }
  const totalCost = totalProductCost + totalServiceCost - discount;

  return [totalProductCost, totalServiceCost, totalCost];
};
